const urlRegex = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
const langUrlRegex = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;

export default {
    getDomain(hostName: string) {
        let reg = urlRegex;
        let name = hostName.split('.')?.slice(-1)?.[0];
        if (name.length > 4 || name === 'com' || name === 'org') reg = langUrlRegex;
        const res = hostName.match(reg);
        const domain = res ? res[0] : '';
        return domain;
    },

    getUrlParams(str?: string) {
        if (!str) return;
        if (str.indexOf('?') === -1) return;
        const o: any = {};
        const params = str.split('?');
        params.forEach((s, y) => {
            if (y > 0) {
                const arrs = s.split('&');
                arrs.forEach(element => {
                    const arr = element.split('=');
                    o[arr[0]] = arr[1];
                });
            }
        })
        return o;
    },

    updateUrlParams(uri: string, key: string, value: string) {
        if (!value) return uri;
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) return uri.replace(re, '$1' + key + '=' + value + '$2');
        return uri + separator + key + '=' + value;
    },

    /**
     * 是否有 http 或者 https, 不含有默认加上 http://
     */
    urlInsertParam(urlString: string, param: string) {
        urlString = urlString.indexOf('http') > -1 ? urlString : 'http://' + urlString;
        let newUrl = new URL(urlString);
        let searchString = newUrl.search;
        searchString += searchString.indexOf('?') > -1 ? '&' : '?';
        searchString += param;
        newUrl.search = searchString;
        return newUrl.toString();
    },

    isDebug() {
        return window.location.href.indexOf('debug=1') !== -1;
    },
    isLocal() {
        return (
            window.location.host.startsWith('localhost') ||
            !!window.location.port ||
            window.location.href.indexOf(`${import.meta.env.VITE_INSIGHT_SERVER_URL_NO_PORT}`) !==
            -1
        );
    },
    isDev() {
        return window.location.host.startsWith('dev.ptmind.');
    },
    isProduction() {
        return import.meta.env.MODE === 'production';
    },
    isHttp() {
        return /^http:\/\//.test(window.location.href);
    },
    isHeatmap() {
        return window.location.href.indexOf('pagescene/heatmap') !== -1;
    }
};
